export default __webpack_public_path__ + "static/media/greenpatch.75807c5f.png";